import { render, staticRenderFns } from "./QutaOffer.vue?vue&type=template&id=6b4315b8&scoped=true&"
import script from "./QutaOffer.vue?vue&type=script&lang=js&"
export * from "./QutaOffer.vue?vue&type=script&lang=js&"
import style0 from "./QutaOffer.vue?vue&type=style&index=0&id=6b4315b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4315b8",
  null
  
)

export default component.exports